import React from "react";
import { createPortal } from "react-dom";

interface YesNoModalPropTypes {
    warningText: string;
    yesText?: string;
    noText?: string;
    modal: { showModal: boolean; payload: any };
    setModal({ showModal, payload }: { showModal: boolean; payload: any }): void;
    onYes?: () => void;
    onNo?: () => void;
}

export const YesNoModal = ({
    warningText,
    onYes,
    onNo = undefined,
    modal,
    setModal,
    yesText = "Delete",
    noText = "Cancel"
}: YesNoModalPropTypes): React.ReactElement => {
    if (!modal.showModal) {
        return <></>;
    }

    return createPortal(
        <div role="dialog" aria-modal="true" aria-labelledby="yesno-title" aria-describedby="yesno-description">
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 2147483646
                }}
                onClick={() => setModal({ showModal: false, payload: null })}
            />
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "white",
                    borderRadius: 8,
                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    zIndex: 2147483647,
                    padding: 24,
                    maxWidth: 480,
                    width: "calc(100% - 2rem)",
                    marginLeft: 16,
                    marginRight: 16
                }}
            >
                <h2
                    id="yesno-title"
                    style={{
                        position: "absolute",
                        width: 1,
                        height: 1,
                        padding: 0,
                        margin: -1,
                        overflow: "hidden",
                        clip: "rect(0,0,0,0)",
                        whiteSpace: "nowrap",
                        border: 0
                    }}
                >
                    Confirmation dialog
                </h2>
                <div id="yesno-description" style={{ whiteSpace: "pre-line" }}>
                    {warningText}
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "center" }}>
                    <button
                        style={{ padding: "8px 16px", background: "#198754", color: "#fff", borderRadius: 6, border: 0, cursor: "pointer" }}
                        onClick={() => {
                            if (onNo) {
                                onNo();
                            }
                            setModal({ showModal: false, payload: null });
                        }}
                    >
                        {noText}
                    </button>
                    <button
                        style={{ padding: "8px 16px", background: "#dc3545", color: "#fff", borderRadius: 6, border: 0, cursor: "pointer" }}
                        onClick={() => {
                            if (onYes) {
                                onYes();
                            }
                            setModal({ showModal: false, payload: null });
                        }}
                    >
                        {yesText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};
